import './App.css';
import React from "react";

import Search from "./components/Search/Search";
import {BrowserRouter, Route, Routes} from "react-router-dom";



function App() {



    return (
        <React.Fragment>
            <BrowserRouter>
                <Routes>
                    <Route exact path='*' element={<Search/>}>

                    </Route>

                </Routes>
            </BrowserRouter>
        </React.Fragment>
    );
}

export default App;
